import React, { useEffect, useState } from "react";
import CCStep1 from "./CCStep1";
import CCStep2 from "./CCStep2";
import CCStep3 from "./CCStep3";
import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-c_cpp";
import "ace-builds/src-noconflict/theme-github";
import { developAxios } from "../../axios.config";
import { useLocation, useParams } from "react-router-dom";

export default function CreateCoding() {
	const { codingId } = useParams<{ codingId: string }>();
	const { pathname } = useLocation();
	const [tab, setTab] = useState<number>(1);
	const [codingData, setCodingData] = useState<ICodingData>({
		outOfScore: 0,
		questionWeigh: 1,
		testcases: [],
		privateTestcases: [],
		questionCode: [],
		name: "",
		description: "",
		sampleInput: "",
		sampleOutput: "",
		languages: [],
		topics: [],
		solutions: [],
		hasScannerInputs: true,
		hasPrivateTestCases: true,
		hidden: true,
	});

	useEffect(() => {
		console.log(pathname);
	}, [pathname]);

	useEffect(() => {
		if (!codingId) return;
		developAxios(localStorage.getItem("token") || "")
			.get<{ questions: ICodingData }>(
				"/admin/coding/GetOneQuestion/" + codingId
			)
			.then(({ data }) => {
				let {
					name,
					description,
					outOfScore,
					questionWeigh,
					testcases,
					privateTestcases,
					questionCode,
					sampleInput,
					sampleOutput,
					languages,
					solutions,
					hasScannerInputs,
					hidden,
					hasPrivateTestCases,
					topics,
				} = data.questions;

				setCodingData({
					name,
					description,
					outOfScore,
					questionWeigh,
					testcases,
					privateTestcases,
					questionCode,
					sampleInput,
					sampleOutput,
					languages,
					solutions,
					hasScannerInputs,
					hasPrivateTestCases,
					hidden,
					topics: topics ? topics : [],
				});
			})
			.catch((err) => console.log(err));
	}, [codingId]);

	function nextPage(val: ICodingData) {
		setCodingData(val);
		console.log(val);
		incTab();
	}

	function setTabComp(tab: number) {
		switch (tab) {
			case 1:
				return <CCStep1 data={codingData} next={nextPage} />;

			case 2:
				return (
					<CCStep2 data={codingData} next={nextPage} prev={decTab} />
				);

			case 3:
				return (
					<CCStep3
						data={codingData}
						prev={decTab}
						submit={submitHandler}
						outOfScore={codingData.outOfScore}
					/>
				);

			default:
				return <React.Fragment />;
		}
	}

	function incTab() {
		setTab((prev) => ++prev);
	}

	function getTestCaseLang(val: language_options): language_options_l {
		switch (val) {
			case "C":
				return "c";
			case "C++":
				return "c++";

			case "Java":
				return "java";

			default:
				return "python3";
		}
	}

	function submitHandler(data: ICodingData) {
		let token = localStorage.getItem("token");
		if (!token) return;
		let solutions: Array<{
			language: language_options;
			codeSolutions: Array<string>;
		}> = [];
		let test_case: Array<
			[
				{
					language: language_options_l;
				},
				Array<{
					scannerInput?: string;
					code?: string;
					name: string;
					output: string;
				}>
			]
		> = [];
		let pvt_test_case: Array<
			[
				{
					language: language_options_l;
				},
				Array<{
					scannerInput?: string;
					code?: string;
					name: string;
					output: string;
					marks: number;
				}>
			]
		> = [];
		data.languages.forEach((value) => {
			let sol = data.solutions.filter((val) => val.language === value)[0];
			solutions.push(sol);

			let test = data.testcases.filter(
				(val) => val[0].language === getTestCaseLang(value)
			)[0];
			let pvt_test = data.privateTestcases.filter(
				(val) => val[0].language === getTestCaseLang(value)
			)[0];
			test_case.push(test);
			pvt_test_case.push(pvt_test);
		});

		if (codingId) {
			developAxios(token)
				.post("/updateQuestion/" + codingId, {
					...data,
					solutions,
					testcases: test_case,
					privateTestcases: pvt_test_case,
				})
				.then(({ data }) => {
					alert("Coding Question Updated Successfully");
					window.open(
						`https://www.cantileverlabs.com/compiler/${codingId}/16`,
						"_blank"
					);
				})
				.catch((err) => alert(err.response.data.message));
		} else {
			developAxios(token)
				.post(
					pathname === "/create-coding-question-dup"
						? "/create-question-new"
						: "/createQuestion",
					{
						...data,
						solutions,
						testcases: test_case,
						privateTestcases: pvt_test_case,
					}
				)
				.then(({ data }) => {
					alert("Uploaded Coding Questions Successfully");
					window.open(
						`https://www.cantileverlabs.com/compiler/${data.questions._id}/16`,
						"_blank"
					);
				})
				.catch((err) => {
					alert(err.response.data.error);
				});
		}
	}

	function decTab(data: ICodingData) {
		setCodingData(data);
		setTab((prev) => --prev);
	}
	return <React.Fragment>{setTabComp(tab)}</React.Fragment>;
}
